import REact from "react";

export default function Checkout() {
    return (<>
        <div className="Pages">Checking Out</div>
    </>)
}
